import { OptionsType, OptionType, SelectProps } from "./types";
import { SELECT_TYPES } from "./constants";
/**
 * Форматирование значения отображаемого в поле ввода селекта
 */
export const formatSelectInputValue = ({
  options,
  searchValue,
  type: selectType,
  searchable,
  expanded,
}: Pick<
  SelectProps,
  "options" | "type" | "searchValue" | "searchable" | "expanded"
>): string => {
  if (selectType === SELECT_TYPES.MULTIPLE) {
    if (searchable) {
      if (expanded) {
        return "";
      }

      const checkedOptionsCount = options.filter(
        ({ checked }) => checked
      ).length;

      if (checkedOptionsCount === 1) {
        return options.find(({ checked }) => checked)?.label || "";
      }

      return checkedOptionsCount ? `Всего выбрано: ${checkedOptionsCount}` : "";
    }

    return options
      .filter(({ checked }) => checked)
      .map(({ label }) => label)
      .join(", ");
  }

  if (searchable && searchValue !== undefined) {
    return searchValue;
  }

  return options.find(({ checked }) => checked)?.label || "";
};

/**
 * Формирует новый массив неотмеченных опций.
 */
export const changeOptionToUnchecked = (options: OptionsType) =>
  options.map((option) => ({
    ...option,
    checked: option.disabled ? option.checked : false,
  }));

/**
 * Формирует новый массив отмеченных опций.
 */
export const getCheckedOptions = (options: OptionsType) =>
  options.filter(({ checked }) => checked);

/**
 * Возвращает дополнительный лейбл единственной выбранной опции.
 */
export const getCheckedAdditionalLabel = (options: OptionsType) => {
  const checkedAdditionalLabels = getCheckedOptions(options).map(
    ({ additionalLabel }) => additionalLabel
  );

  const firstCheckedLabel = checkedAdditionalLabels[0];

  if (checkedAdditionalLabels.length === 1 && firstCheckedLabel) {
    return firstCheckedLabel;
  }
};

/**
 * Функция фильтрации опций для отображения на основе введённого пользователем текста.
 * Используется в "searchable" режиме.
 */
export const filterOptions = (options: OptionType[], searchValue: string) =>
  options.filter(
    ({ label, content }) =>
      !content && label.toLowerCase().includes(searchValue.toLowerCase())
  );

export const defaultOptionSelectionComparator = (
  option: OptionType,
  selectedOption: OptionType
) => option.label === selectedOption.label;
